import React from 'react';
import { Box, Checkbox, FormControlLabel, Slider, styled, TextField } from '@mui/material';

const IOSSlider = styled(Slider)(({ theme }) => ({
  color: theme.palette.mode === "dark" ? "#3880ff" : "#007aff",
  height: 4,
  padding: "15px 0",
  "& .MuiSlider-thumb": {
    height: 24,
    width: 24,
    backgroundColor: "#fff",
    boxShadow: "0 0 4px rgba(0, 0, 0, 0.3)",
    "&:focus, &:hover, &.Mui-active": {
      boxShadow: "0 0 8px rgba(0, 122, 255, 0.6)",
    },
  },
  "& .MuiSlider-rail": {
    opacity: 0.3,
    backgroundColor: "#bfbfbf",
  },
  "& .MuiSlider-track": {
    border: "none",
  },
}));


function RowFeild({
  label,
  checked = false,
  onCheckboxChange,
  sliderValue = 0,
  onSliderChange,
  sliderMin = 0,
  sliderMax = 1000000,
  sliderStep = 1000,
  inputValue = '',
  onInputChange,
  inputLabel = 'Value',
  inputType = 'number',
  ...props
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: { xs: 0.5, sm: 1 },
        p: 1,
        flexWrap: 'nowrap',
        width: '100%',
        marginLeft: "15px"
      }}
      {...props}
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={onCheckboxChange}
            size="small"
          />
        }
        label={label}
        sx={{
          minWidth: { xs: '100px', sm: '120px' },
          '& .MuiFormControlLabel-label': {
            fontSize: { xs: '0.875rem', sm: '1rem' },
          },
        }}
      />
      {checked && (
        <>
          <Box sx={{ flex: 1, minWidth: { xs: '150px', sm: '150px' } }}>
            {/* <Slider
              value={sliderValue}
              onChange={onSliderChange}
              min={sliderMin}
              max={sliderMax}
              step={sliderStep}
              valueLabelDisplay="auto"
              size="small"
            /> */}
            <IOSSlider
        value={sliderValue}
        onChange={onSliderChange}
        min={sliderMin}
        max={sliderMax}
        step={sliderStep}
        valueLabelDisplay="auto"
       
      />
          </Box>
          <TextField
            label={inputLabel}
            type={inputType}
            value={inputValue}
            onChange={onInputChange}
            variant="outlined"
            size="small"
            sx={{
              minWidth: { xs: '80px', sm: '100px' },
              '& .MuiInputLabel-root': {
                fontSize: { xs: '0.75rem', sm: '0.875rem' },
              },
              '& .MuiInputBase-input': {
                fontSize: { xs: '0.75rem', sm: '0.875rem' },
              },
            }}
          />
        </>
      )}
    </Box>
  );
}

export default RowFeild;
